// extracted by mini-css-extract-plugin
module.exports = {"collection-item":"CollectionItem_collection-item__3DIHK","empty":"CollectionItem_empty__ERjoR","item-image":"CollectionItem_item-image__8AJcf"};